import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { MiniCta } from '../CtaBlock';
import { faqs } from '../../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-ink-800 px-4 py-14 sm:px-6 sm:py-20" data-id="element-111" data-mp="x53bswgcnx95">
      <div className="mx-auto max-w-2xl" data-id="element-112" data-mp="1223kzg8hxg4h">
        <p className="text-center font-display text-xs font-bold uppercase tracking-[0.22em] text-arc-light" data-id="element-113" data-mp="122vfenqcx7t6">
          ❓ Risposte chiare
        </p>
        <h2 className="mt-3 text-center font-display text-3xl font-bold uppercase leading-tight text-bone sm:text-5xl" data-id="element-114" data-mp="1urtypo67ug02">
          Domande Frequenti
        </h2>

        <ul className="mt-8 space-y-2.5" data-id="element-115" data-mp="1g0blfy4qqzke">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <li key={faq.q} className="overflow-hidden rounded-xl border border-ink-500 bg-ink-700" data-id="element-116" data-mp="28qjv11l7obnd" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left transition-colors duration-150 ease-out hover:bg-ink-600 focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-arc" data-id="element-117" data-mp="2di1vzpn8ic8c">
                  <span className="font-display text-lg font-bold uppercase leading-tight text-bone" data-id="element-118" data-mp="2tnqs7o6cli7k">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-arc-light transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-119" data-mp="32i59txecp4tu" />
                </button>
                {isOpen && <p className="border-t border-ink-500 px-4 py-4 text-[15px] leading-relaxed text-mute" data-id="element-120" data-mp="1n1oc28cktsun">
                    {faq.a}
                  </p>}
              </li>;
        })}
        </ul>

        <MiniCta label="Ho capito, voglio accedere" data-id="element-121" data-mp="27s0o4kksqtbu" />
      </div>
    </section>;
}